"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverflowDropdown = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var react_1 = tslib_1.__importStar(require("react"));
var react_resize_detector_1 = require("react-resize-detector");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Dropdown_1 = require("../Dropdown");
exports.OverflowDropdown = function (_a) {
    var _b, _c;
    var children = _a.children, _d = _a.dropdownButtonProps, dropdownButtonProps = _d === void 0 ? {} : _d;
    var _e = react_resize_detector_1.useResizeDetector(), width = _e.width, ref = _e.ref;
    var _f = react_1.useState(false), isDropdownOpen = _f[0], setIsDropdownOpen = _f[1];
    var _g = react_1.useState(null), anchorEl = _g[0], setAnchorEl = _g[1];
    var _h = react_1.useState(0), lastVisibleChild = _h[0], setLastVisibleChild = _h[1];
    var _j = react_1.useState(0), lastVisibleChildRight = _j[0], setLastVisibleChildRight = _j[1];
    var buttonRef = react_1.useRef(null);
    var numChildren = react_1.useMemo(function () { return react_1.default.Children.count(children); }, [children]);
    var onClickDropdown = function (event) {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setIsDropdownOpen(function (prevIsDropdownOpen) { return !prevIsDropdownOpen; });
    };
    var onCloseDropdown = function () {
        setAnchorEl(null);
        setIsDropdownOpen(false);
    };
    var handleChild = react_1.useCallback(function (index) {
        return function (el) {
            if (!el || typeof width === 'undefined' || !buttonRef.current) {
                return;
            }
            var offsetLeft = el.offsetLeft, offsetWidth = el.offsetWidth;
            var offsetRight = offsetLeft + offsetWidth;
            var overflowTarget = width - buttonRef.current.offsetWidth;
            if (index === numChildren - 1) {
                overflowTarget = width;
            }
            if (offsetRight < overflowTarget) {
                setLastVisibleChild(index);
                setLastVisibleChildRight(offsetRight);
            }
            else if (index === 0) {
                setLastVisibleChildRight(offsetRight);
            }
        };
    }, [width]);
    var maxChildWidth = (width !== null && width !== void 0 ? width : 0) - (numChildren > 1 ? (_c = (_b = buttonRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) !== null && _c !== void 0 ? _c : 0 : 0);
    return (react_1.default.createElement(Container, { ref: ref },
        children &&
            react_1.default.Children.map(children, function (child, index) { return (react_1.default.createElement(ChildContainer, { "$maxWidth": index === 0 ? maxChildWidth : undefined, "$show": index <= lastVisibleChild, ref: handleChild(index), "data-testid": "overflowdropdown-child-" + index }, child)); }),
        react_1.default.createElement(DropdownButton, tslib_1.__assign({ "$show": numChildren - lastVisibleChild > 1, onClick: onClickDropdown, "$selected": isDropdownOpen, "$left": lastVisibleChildRight, ref: buttonRef }, dropdownButtonProps),
            "+",
            numChildren - lastVisibleChild - 1,
            isDropdownOpen ? react_1.default.createElement(StyledArrowDropUp, null) : react_1.default.createElement(StyledArrowDropDown, null)),
        react_1.default.createElement(Dropdown_1.Dropdown, { anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            }, anchorEl: anchorEl, open: isDropdownOpen, onClose: onCloseDropdown },
            react_1.default.createElement(DropdownContainer, null, children))));
};
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex: 1;\n  position: relative;\n  overflow: hidden;\n"], ["\n  display: flex;\n  flex: 1;\n  position: relative;\n  overflow: hidden;\n"])));
var ChildContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ",
    "\n"])), function (_a) {
    var $maxWidth = _a.$maxWidth;
    return ($maxWidth ? "max-width: " + $maxWidth + "px;" : '');
}, function (_a) {
    var $show = _a.$show;
    return $show
        ? "\n            opacity: 1;\n        "
        : "\n            opacity: 0;\n            height: 0;\n            pointer-events: none;\n        ";
});
var DropdownButton = styled_components_1.default(core_1.ButtonBase)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  position: absolute !important;\n  left: ", "px !important;\n  width: 4.8rem;\n  height: 2rem;\n  ", "\n  font-size: 1.2rem;\n  background-color: ", " !important;\n  color: ", " !important;\n"], ["\n  position: absolute !important;\n  left: ", "px !important;\n  width: 4.8rem;\n  height: 2rem;\n  ",
    "\n  font-size: 1.2rem;\n  background-color: ",
    " !important;\n  color: ", " !important;\n"])), function (_a) {
    var $left = _a.$left;
    return $left;
}, function (_a) {
    var $show = _a.$show;
    return $show
        ? "\n            opacity: 1;\n        "
        : "\n            opacity: 0;\n            height 0;\n            pointer-events: none;\n        ";
}, function (_a) {
    var $selected = _a.$selected;
    return $selected ? '#252627' : 'transparent';
}, function (_a) {
    var $selected = _a.$selected;
    return ($selected ? '#FFFFFF' : '#6B6E6F');
});
var StyledArrowDropDown = styled_components_1.default(icons_1.ArrowDropDown)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  width: 1.8rem !important;\n  height: 1.8rem !important;\n"], ["\n  width: 1.8rem !important;\n  height: 1.8rem !important;\n"])));
var StyledArrowDropUp = styled_components_1.default(icons_1.ArrowDropUp)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  width: 1.8rem !important;\n  height: 1.8rem !important;\n"], ["\n  width: 1.8rem !important;\n  height: 1.8rem !important;\n"])));
var DropdownContainer = styled_components_1.default.div(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  padding: 0.9rem;\n  max-width: 19.8rem;\n"], ["\n  padding: 0.9rem;\n  max-width: 19.8rem;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
